import { type FunctionComponent, } from "react";
import * as IC from "../../assets/icons/social";
import { TwitterShareButton, } from "react-share";
import { usePointsStore, } from "@stores/points";
import "./SocialBar.scss";


export declare type SocialBarProps = {

};



export const SocialBar: FunctionComponent<SocialBarProps> = () => {

	const {
		users_referral_id,
	} = usePointsStore();

	const onOpen = ( platform: "x"|"discord"|"telegram") => {
		switch( platform ) {
			case "x": return window.open("https://twitter.com/Bracket_fi", "_blank");
			case "discord": return window.open("https://discord.gg/bracket", "_blank");
			case "telegram": return window.open("https://t.me/bracket_community", "_blank");
		}
	}

	const classes = () => [ "social-bar" ].join(" ");

	return (
		<div className={classes()}>
			<div className="social x" onClick={evt => onOpen("x")}><IC.X /></div>
			<div className="social discord" onClick={evt => onOpen("discord")}><IC.Discord /></div>
			<div className="social telegram" onClick={evt => onOpen("telegram")}><IC.Telegram /></div>
		</div>
	);
}
